module.exports = __webpack_public_path__ + "img/icon-location@2x.ad3bad94.png";